export default ['message', 'primary', 'info', 'success', 'warning', 'danger'];



// WEBPACK FOOTER //
// ./resources/js/components/enso/bulma/toastr/config/types.js